export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE";

export const LOG_IN_REQUEST = "LOG_IN_REQUEST";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_FAILURE = "LOG_IN_FAILURE";

export const TOGGLE_TO_REGISTER = "TOGGLE_TO_REGISTER";
export const TOGGLE_TO_LOGIN = "TOGGLE_TO_LOGIN";
export const TOGGLE_TO_FORGET = "TOGGLE_TO_FORGET";

export const LOGIN_WITH_GOOGLE = "LOGIN_WITH_GOOGLE";
export const LOGIN_WITH_FACEBOOK = "LOGIN_WITH_FACEBOOK";

export const REGISTER_REQUEST_WITH_GOOGLE = "REGISTER_REQUEST_WITH_GOOGLE";
export const REGISTER_REQUEST_WITH_FACEBOOK = "REGISTER_REQUEST_WITH_FACEBOOK";

export const REGISTER_WITH_GOOGLE_SUCCESS = "REGISTER_WITH_GOOGLE_SUCCESS";
export const REGISTER_WITH_FACEBOOK_SUCCESS = "REGISTER_WITH_FACEBOOK_SUCCESS";

export const LOG_OUT = "LOG_OUT";

export const GET_USER_ID = "GET_USER_ID";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";


export const FETCH_IN_CART_REQUEST = "FETCH_IN_CART_REQUEST";
export const FETCH_IN_CART_SUCCESS = "FETCH_IN_CART_SUCCESS";
export const FETCH_IN_CART_FAILURE = "FETCH_IN_CART_FAILURE";

export const FINAL_CART_SET_SUCCESS = "FINAL_CART_SET_SUCCESS";
